import React from 'react';
import './SectionDivider.css';

export default function SectionDivider(){
	return <div className='section-divider'/>
}



// WEBPACK FOOTER //
// ./src/components/common/SectionDivider.js